// Segment Feature Barrel Export
// This file exports all public modules from the Segment feature

// Core initialization
export * from './initialize'

// Actions
export * from './actions'

// Constants
export * from './constants'

// Track action functionality
export { trackAction } from './trackAction'

// Interfaces and Types
export * from './interfaces'
export * from './types'

// Helpers
export * from './helpers/getContext'
export * from './helpers/dataAnonymizer'

// Middlewares
export { default as segmentMiddleware } from './middlewares/segment'

// Plugins
export {
  default as SegmentTrackingPlugin,
  createAnonymizeTrackPlugin
} from './plugins/segmentEventTracking'
